import React, { } from "react";
// import ProductionProcessTable from "../../Masters/Brand/ProductionProcessTable";
import ProductionProcessTable from "./ProductionProcessTable";


function PumpProductionProcessTable() {

  let header = [
    { label: "Id", field: "id" },
    { label: "PO No.", field: "productionordernumber" },
    { label: "Part Number", field: "partno" },
    { label: "Job Number", field: "jobnumber" },
    { label: "roughmachine", field: "roughmachine" },
    { label: "fabrication", field: "fabrication" },
    { label: "finalmachining", field: "finalmachining" },
    { label: "accept / reject", field: "acceptorreject" },

  ];

  return (
    <div>
      <ProductionProcessTable
        header={header}
        tableTitle={"PRODUCTION PROCESS LIST"}
        apiField={"productionprocess"}
        type={"Pump"}
        addButton={"+ ADD"}
        createRoute={"/pump-production-process-add"}
        updateRoute={"/pump-production-process-view"}
        viewRoute={"/pump-production-process-view"}
      />
    </div>
  );
}

export default PumpProductionProcessTable;